import confirmResetPasswordTranslation from './index.json';

export default confirmResetPasswordTranslation;
